const getters = {
    loginForm: state => state.user.loginForm,
    userData: state => state.user.userData,
    msid: state => state.user.msid,
    menus: state => state.common.desktopMenus,
}
  export default getters;



// WEBPACK FOOTER //
// ./src/modules/desktop/store/getters.js